import { AbstractControl, ValidationErrors } from '@angular/forms';

import { DeviceType } from '../models/firebase.model';
import { ProductModelService } from '../models';

export const deviceSerialValidator = (type?: DeviceType[]) =>
  (control: AbstractControl): ValidationErrors | null => {
    const deviceId = control.value.trim();
    if (!deviceId) {
      return null;
    }

    const product = new ProductModelService(deviceId);
    const typeKeys: string[] = [
      'inverter',
      'meter',
      'evcharge',
      'connext',
      'enerclic',
      'no-zcs',
    ];

    if (!product.type?.name) {
      return { genericError: true };
    }

    const isValidType = type?.length
      ? type.includes(product.type.name)
      : typeKeys.includes(product.type.name);

    return isValidType ? null : { serialNotValid: true };
  };
